module.exports = __webpack_public_path__ + "static/img/h4-2.1128ac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h4-2.png
// module id = PoYr
// module chunks = 1